const resultados = {

    bomberos: {
        titulo_seccion:"Diplomas y Resultados",
        tabla: "BOMBEROS_2026_RESULTADOS",
        titulo: "Corre con los Bomberos 2026",
        descripcion: "Consultar resultados y ver mi diploma",
        imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/799264483_1939069984166907_9047002007919592340_n.jpg",
    },
    chiguata_trail:{
        titulo_seccion:"Diplomas y Resultados",
        tabla: "AQP_TRAIL_CHIGUATA_2026",
        titulo: "Los Andenes de Chiguata 2026",
        descripcion: "Consultar resultados y ver mi diploma",
        imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/DIPLOMA_BUSQUEDA.jpg",
    },
    joya_ciclismo:{
        titulo_seccion:"Diplomas y Resultados",
        tabla: "JOYA_CICLISMO_2026",
        titulo: "LSL MTB: El Señor de la Joya 2026",
        descripcion: "Consultar resultados y ver mi diploma",
        imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/LSL%20MTB%20JOYA%202026/CHAMPION2.jpg",
    },

    chilina_trail:{
        titulo_seccion:"Diplomas y Resultados",
        tabla: "AQP_TRAIL_CHILINA_2026",
        titulo: "El Valle de Chilina 2026",
        descripcion: "Consultar resultados y ver mi diploma",
        imagen:"https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/AQP_TRS_CHILINA_2026/DIPLOMAS.jpg",
    },

};

export default resultados;